<div class="flex align-items-center justify-content-center w-full font-bold border-round m-2 text-3xl title-case">
    Customer Support Activation
</div>
<p-card>
    <form [formGroup]="customerSupportForm">
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-4">
                <label for="partnerId font" class="required-field">Partner ID : </label>
                <div clas="mt-2">
                    <p-dropdown [filter]="true" name="partnerId" placeholder="Select Partner Id"
                        (onChange)="onChangePartnerId($event)" [virtualScroll]="true" styleClass="w-8" 
                        [options]="partnerDetails" optionLabel="partnerId" formControlName="partnerId">
                    </p-dropdown>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
                <label for="partnerId" class="required-field">Product Code :</label>
                <div *ngIf="isProductDataAvailable">
                    <p-dropdown [filter]="true" name="productCode" placeholder="Select Product Code"
                        [virtualScroll]="true" styleClass="w-8" formControlName="productCode" optionLabel="name" [editable]="true"
                        [options]="productCodeList" (onChange)="onChangeProductCode($event)" optionValue="value">
                    </p-dropdown>
                    <div *ngIf="!customerSupportForm.controls['productCode']?.valid && customerSupportForm.controls['productCode'].dirty && isError"
                    class="error-msg">
                    <span *ngIf="customerSupportForm.controls['productCode']?.hasError('pattern')">
                        Enter valid product code format(0000-00-0){{customerSupportForm.value.productCode.name}}</span>
                    </div>
                </div>
                <div *ngIf="!isProductDataAvailable">
                    <p-inputMask formControlName="productCode" mask="9999-99-9" styleClass="w-8"></p-inputMask>
                    <div *ngIf="!customerSupportForm.controls['productCode'].valid && customerSupportForm.controls['productCode'].dirty"
                        class="error-msg">
                        <span *ngIf="customerSupportForm.controls['productCode']?.hasError('required')" class="error-msg">
                            Product Code is required</span>
                    </div>
                </div>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
                <label for="partnerName">Partner Name : </label>
                <div>
                    <input type="text" pInputText name="partnerName" value="{{selectedPartnerName}}" class="w-8"
                        disabled>
                </div>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
                <label for="pac" class="required-field">PAC : </label>
                <div>
                    <input id="pac" type="text" pInputText class="w-8" formControlName="pac"  maxlength="13"
                    minlength="12">
                    <div *ngIf="!customerSupportForm.controls['pac'].valid && customerSupportForm.controls['pac'].dirty"
                    class="error-msg">
                    <span *ngIf="customerSupportForm.controls['pac']?.hasError('required')">
                        PAC is required</span>
                    <span *ngIf="customerSupportForm.controls['pac']?.hasError('minlength') && !customerSupportForm.controls['pac']?.hasError('pattern')">
                        Minimum length of the PAC should be 12</span>
                    <span *ngIf="customerSupportForm.controls['pac']?.hasError('maxlength') && !customerSupportForm.controls['pac']?.hasError('pattern')">
                        Maximum length of the PAC should be 13</span>
                    <span *ngIf="customerSupportForm.controls['pac']?.hasError('pattern')">
                        PAC should be alpha numeric
                    </span>
                </div>
                </div>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
                <label for="partnerId" class="required-field">Receiver Manufacturer : </label>
                <div>
                    <p-dropdown [filter]="true" name="receiverManufacturer" [options]="recieverManufacturerResponse"
                        optionLabel="manufacturerName" placeholder="Select Manufacturer"
                        formControlName="receiverManufacturer" styleClass="w-8">
                    </p-dropdown>
                </div>
            </div>

            <div class="col-12 md:col-6 lg:col-12">
                <p-panel header="Activation">
                    <div class="grid flex align-items-center justify-content-center">
                        <div class="col-12 md:col-6 lg:col-3">
                            <p-radioButton name="isImmediateActivation" label="Immediate Activation"
                                formControlName="isImmediateActivation" [value]="true" class="w-10" (onClick)="onImmediateActivation()">
                            </p-radioButton>
                
                        </div>
                        <div class="col-12 md:col-6 lg:col-2">
                            <p-radioButton name="isImmediateActivation" [value]="false" label="Scheduled"
                                formControlName="isImmediateActivation" (onClick)="onScheduledActivation()">
                            </p-radioButton>
                        </div>
                    </div>
                    <div class="grid flex align-items-center justify-content-center">
                        <div class="col-12 md:col-6 lg:col-4">
                            <label for="startDate" class="required-field">Start Date : </label>
                            <p-calendar formControlName="startDate" styleClass="w-8"
                                 appendTo="body"
                                 hourFormat="24" 
                                 [showIcon]="true"
                                 [showTime]= "true"  
                                 dateFormat="MM dd yy"
                                 [minDate]="minScheduledActivationStartDate"
                                 (onSelect)="validateStartDate($event)"
                                 [maxDate]="maxDate"
                                 [readonlyInput]="true"
                                 [showButtonBar]="true"
                                 (onTodayClick)="onTodayClick()"
                                 >
                            </p-calendar>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <label for="endDate" class="required-field">End Date : </label>
                            <p-calendar formControlName="endDate" styleClass="w-8" 
                                appendTo="body"
                                hourFormat="24" 
                                [showIcon]="true"
                                (onSelect)="validateEndDate($event)" 
                                dateFormat="MM dd yy"
                                [minDate]="minScheduledActivationEndDate"
                                [readonlyInput]="true">
                            </p-calendar>
                        </div>
                        <div class="col-12 md:col-6 lg:col-6 flex align-items-center justify-content-center">
                            <span class="error-msg">{{showMessage}}</span>
                        </div>
                    </div>
                </p-panel>
            </div>
        </div>
        <div class="flex justify-content-center flex-wrap">
            <div class="flex align-items-center justify-content-center w-15rem h-4rem font-bold border-round m-4">
                <button pButton type="button" label="Submit" class="btnClass" (click)="saveCustomerDetails()"
                    [disabled]="customerSupportForm.invalid || showMessage"></button>
            </div>
        </div>
    </form>
</p-card>
<p-toast position="top-center" life="4000"></p-toast>
